<script lang="ts">
  import { login } from '../lib/api';
  import type { WhoAmI } from '../lib/api';

  type Props = { onsuccess: (who: WhoAmI) => void };
  let { onsuccess }: Props = $props();

  let username = $state('');
  let password = $state('');
  let busy = $state(false);
  let err = $state('');

  async function submit(e: Event): Promise<void> {
    e.preventDefault();
    err = '';
    busy = true;
    try {
      const w = await login(username, password);
      onsuccess(w);
    } catch (e) {
      err = e instanceof Error ? e.message : String(e);
    } finally {
      busy = false;
    }
  }
</script>

<div class="bg">
  <form class="card" onsubmit={submit}>
    <div class="brand">
      <div class="logo">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
             stroke-linecap="round" stroke-linejoin="round">
          <path d="M23 7l-7 5 7 5V7z" />
          <rect x="1" y="5" width="15" height="14" rx="2" />
        </svg>
      </div>
      <h1>sarmatcam</h1>
    </div>
    <label>
      Логин
      <input bind:value={username} autocomplete="username" required autofocus />
    </label>
    <label>
      Пароль
      <input type="password" bind:value={password} autocomplete="current-password" required />
    </label>
    <div class="err">{err}</div>
    <button type="submit" disabled={busy}>{busy ? 'Вход…' : 'Войти'}</button>
  </form>
</div>

<style>
  .bg {
    position: fixed; inset: 0;
    display: grid; place-items: center;
    background: var(--bg);
    padding: 1em;
  }
  .card {
    width: min(360px, 100%);
    background: var(--bg-elev);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    padding: 28px;
    display: flex; flex-direction: column; gap: 14px;
    backdrop-filter: blur(20px) saturate(180%);
  }
  .brand { display: flex; align-items: center; gap: 12px; margin-bottom: 6px; }
  .logo {
    width: 40px; height: 40px;
    border-radius: 9px;
    background: linear-gradient(135deg, var(--accent), #5e5ce6);
    display: grid; place-items: center;
  }
  .logo :global(svg) { width: 22px; height: 22px; color: #fff; }
  h1 { font-size: 18px; font-weight: 600; letter-spacing: -.01em; margin: 0; }
  label { display: flex; flex-direction: column; gap: 4px; font-size: 12px; color: var(--fg-muted); font-weight: 500; }
  input {
    padding: 10px 12px; border-radius: 8px;
    border: 1px solid var(--border);
    background: var(--bg); color: var(--fg);
    font-size: 14px;
  }
  input:focus { outline: 2px solid var(--accent); outline-offset: -1px; border-color: var(--accent); }
  .err { color: var(--bad); font-size: 13px; min-height: 1.2em; }
  button {
    background: var(--accent); color: #fff;
    padding: 10px 14px; border-radius: 8px; font-weight: 600;
    margin-top: 4px;
  }
  button:disabled { opacity: .6; cursor: default; }
  button:hover:not(:disabled) { filter: brightness(1.08); }
</style>
